import z from "zod";
import { definePluginEvents } from "@/plugins/server/builder";
import type { PluginEvent } from "@/plugins/server/types";
import { messageSchema } from "@/shared/messages";

export const memoriesPluginEventsDef = definePluginEvents(
  {
    name: "cache-build",
    dataSchema: z.object({
      messagesHash: z.string(),
      memories: z.array(messageSchema),
    }),
  },
  {
    name: "cache-memory",
    dataSchema: z.object({
      name: z.string(),
      messages: z.array(messageSchema),
      timestamp: z.number(),
    }),
  },
);

export type MemoriesPluginEvent<T extends "input" | "output"> = PluginEvent<
  typeof memoriesPluginEventsDef,
  T
>;
